<template>
  <GModal class="modal--crop-photo normalize-gutter">
    <div slot="header">
      <div class="show-desktop">
        <button type="button" class="close" aria-label="Close">
          <img src="/assets/img/icons/close-modal.svg" alt="icon-close-modal" @click.prevent="closeModal" />
        </button>
      </div>

      <div class="show-mobile">
        <button type="button" class="close" aria-label="Close">
          <img src="/assets/img/icons/back.svg" @click.prevent="closeModal" />
        </button>

        <h2 class="modal-heading modal-heading__header">ADD PHOTO</h2>
      </div>
    </div>
    <div slot="body">
      <div ref="content-photo" class="content-photo">
        <croppa
          v-model="croppa"
          class="result"
          :prevent-white-space="true"
          :initial-image="imageForCrop.file"
          initial-size="cover"
          :quality="1"
          :height="350"
          :width="width"
          :file-size-limit="5242880"
          :accept="'image/jpg,image/jpeg,image/png'"
          :placeholder="'Drag and drop photos at any time'"
          @file-size-exceed="onFileSizeExceed"
          @file-choose="onFileChoose"
          @image-remove="(isFileChoose = false), (fileSizeExceed = false)"
        >
        </croppa>
        <div class="guideframe"><span></span><span></span><span></span><span></span></div>
      </div>
      <p class="copyright text-center">Move and scale to zoom or crop</p>
      <!-- <croppa v-model="croppa"
					:initial-image="imageForCrop.file"
					initial-size="cover"
					:quality="1"
					:height="350"
					:width="width"
					:file-size-limit="5242880"
					:accept="'image/jpg,image/jpeg,image/png'"
					:placeholder="'Drag and drop photos at any time'"
					@file-size-exceed="onFileSizeExceed"
					@file-choose="onFileChoose"
					@image-remove="isFileChoose = false, fileSizeExceed = false"
					>
				</croppa>
					<div class="guideframe">
						<span></span><span></span><span></span><span></span>
					</div>

				<p class="copyright text-center">Move and scale to zoom or crop</p> -->
    </div>
    <div slot="footer">
      <div class="text-center">
        <a href="" class="btn btn-dark" @click.prevent="saveCrop">SAVE</a>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'modal-crop-photo',
  data() {
    return {
      croppa: {},
      isFileChoose: false,
      fileSizeExceed: false,
      fileAfterCrop: '',
    };
  },
  computed: {
    imageForCrop() {
      return this.$store.state.writeReview.imageForCrop;
    },
    screen() {
      return this.$store.state.screen;
    },
    width() {
      if (this.screen.width > 740) {
        return 540;
      } else {
        return this.screen.width - 30;
      }
    },
  },
  methods: {
    closeModal() {
      this.$store.dispatch('setModalCropPhoto', false);
    },
    onFileSizeExceed() {},
    onFileChoose() {},
    saveCrop() {
      const isCropOnTemporaryData = this.$store.state.writeReview.showModalUploadPhoto;

      this.fileAfterCrop = this.croppa.generateDataUrl('image/jpeg', 0.8);

      if (isCropOnTemporaryData) {
        this.$store.dispatch('updateTemporaryProductShotImage', {
          productShotKey: this.imageForCrop.productShotKey,
          file: this.fileAfterCrop,
        });
      } else {
        this.$store.dispatch('updateProductShotImage', {
          productShotKey: this.imageForCrop.productShotKey,
          file: this.fileAfterCrop,
        });
      }

      this.$store.dispatch('setModalCropPhoto', false);
    },
  },
};
</script>
